export default "__VITE_ASSET__CuYM18Pi__"